import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__audits_login',
    path: '/audits/login/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/login.vue' /* webpackChunkName: "pages-auth-login.vue" */
        )
      )
  },
  {
    name: '__audits_password_reset',
    path: '/audits/password-reset/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/password-reset.vue' /* webpackChunkName: "pages-auth-guest-password-reset.vue" */
        )
      )
  },
  {
    name: '__audits_password_set',
    path: '/audits/password-set/',
    component: () =>
      interopDefault(
        import(
          '~/pages/auth/password-set.vue' /* webpackChunkName: "pages-auth-guest-password-set.vue" */
        )
      )
  }
]
